import React from 'react';
import { StyleSheet, View } from 'react-native';
import { MenuFlowProvider } from '../MenuFlowProvider';
import { useMainTabModel } from './useMainTabModel';
import { MainTabNavigatorPlatform } from './MainTabNavigator';

const styles = StyleSheet.create({
  root: {
    flex: 1,
  },
});

/**
 * Main tabs — iOS native SF Symbol tab bar · Android Material JS tabs · web uses Material tabs.
 * Post-auth Dashboard focus comes from root RESET (`MainTabs` + `screen: 'Dashboard'`),
 * not a nested `navigate('Dashboard')` from this wrapper (parent nav has no Dashboard route).
 */
export function TabNavigator() {
  const model = useMainTabModel();

  return (
    <MenuFlowProvider>
      <View style={styles.root}>
        <MainTabNavigatorPlatform model={model} />
      </View>
    </MenuFlowProvider>
  );
}
